/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Home_TitleInputs */

const en_meta_home_title = /** @type {(inputs: Meta_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Automation Agency in Latvia — Custom AI Systems | Lindevo`)
};

const lv_meta_home_title = /** @type {(inputs: Meta_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI automatizācija uzņēmumiem Latvijā — AI risinājumi | Lindevo`)
};

/**
* | output |
* | --- |
* | "AI Automation Agency in Latvia — Custom AI Systems \| Lindevo" |
*
* @param {Meta_Home_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_home_title = /** @type {((inputs?: Meta_Home_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Home_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_home_title(inputs)
	return en_meta_home_title(inputs)
});